module.exports = __webpack_public_path__ + "media/browser/chrome-ac5f2f92.svg";